     <template>
  <modal
    id="sms-modal"
    name="sms-modal"
    :draggable="isMobile() ? false : '.modal-header'"
    class="sms-modal"
    width="450"
    height="auto"
    @opened="getLink"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Social Media</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="$modal.hide('sms-modal');"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="sms-modal-contactus-list">
          <social-sharing
            :url="customURL"
            title="Wałbrzyska Specjalna Strefa Ekonomiczna"
            description="Mapa terenów inwestycyjnych Wałbrzyskiej Specjalnej Strefy Ekonomicznej"
            quote="Wałbrzyska Specjalna Strefa Ekonomiczna INVEST-PARK sp. z o.o."
            hashtags="WSSE, ZnaczySukces ,Współpraca, Rozwój, Inwestycje"
            twitter-user="WalbrzyskaSSE"
            inline-template
          >
            <div>
              <ul class="social-media-list">
                <li>
                  <network network="email">
                    <i class="fas fa-envelope"></i> Email
                  </network>
                </li>
                <li>
                  <network network="facebook">
                    <i class="fab fa-facebook-f"></i> Facebook
                  </network>
                </li>
                <li>
                  <network network="googleplus">
                    <i class="fab fa-google-plus-square"></i> Google +
                  </network>
                </li>
                <li>
                  <network network="linkedin">
                    <i class="fab fa-linkedin-in"></i> LinkedIn
                  </network>
                </li>
                <li>
                  <network network="twitter">
                    <i class="fab fa-twitter"></i> Twitter
                  </network>
                </li>
              </ul>
            </div>
          </social-sharing>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  data() {
    return {
      customURL: ""
    };
  },
  methods: {
    getLink() {
      this.customURL = window.location.href.toString();
    }
  }
};
</script>
<style>
.social-media-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.social-media-list li {
  margin: 5px 0px;
}
.social-media-list li span i {
  width: 35px;
  font-size: 20px;
  text-align: center;
}
.social-media-list li span {
  font-size: 16px;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
}
.social-media-list li span:hover {
  color: #294c70;
}
.sms-modal .modal-content {
  border: 0;
}
</style>